// src/hooks/useFinishBattle.js
import { useState } from "react";
import { finishBattle as finishBattleApi } from "../api/battleApi";

export function useFinishBattle() {
  const [finishing, setFinishing] = useState(false);

  // ✅ battleId, workRecordId 둘 다 받기
  const doFinishBattle = async (battleId, workRecordId) => {
    setFinishing(true);
    try {
      // ✅ API에 그대로 전달
      await finishBattleApi(battleId, workRecordId);
    } catch (err) {
      throw err;
    } finally {
      setFinishing(false);
    }
  };

  return { finishing, finishBattle: doFinishBattle };
}
